import {FIELDS_LIST} from "../feature/services/connettori";

const evaluateQuestionOutputValue = (output, context) => {
  const { output_input_id, metadata_ } = output;

  const response = context.responses[output_input_id];
  if (!response) {
    console.warn(`Can't render output ${output.id} because response ${output_input_id} cannot be found`);
    return null;
  }

  if (!!response.option)
    return response.option;

  return !metadata_?.field
    ? response.value
    : (
      FIELDS_LIST[metadata_.field]?.options
        ? FIELDS_LIST[metadata_.field].options[response.value[metadata_.field]]
        : response.value[metadata_.field]
    );
};

export default evaluateQuestionOutputValue;
